import React from "react";
export const ChevronLeft: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.25001 14.0608L4.92679 9.73755C4.24337 9.05413 4.24337 7.94609 4.92679 7.26268L9.25001 2.93945L10.3107 4.00011L5.98745 8.32334C5.88981 8.42097 5.88981 8.57926 5.98745 8.67689L10.3107 13.0001L9.25001 14.0608Z"
      fill="#161C22"
    />
  </svg>
);
